/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DashboardAbsenceSearch
 */
export interface DashboardAbsenceSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardAbsenceSearch
     */
    apprenant?: TextSearch;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardAbsenceSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardAbsenceSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardAbsenceSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardAbsenceSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAbsenceSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardAbsenceSearch interface.
 */
export function instanceOfDashboardAbsenceSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAbsenceSearchFromJSON(json: any): DashboardAbsenceSearch {
    return DashboardAbsenceSearchFromJSONTyped(json, false);
}

export function DashboardAbsenceSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAbsenceSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apprenant': !exists(json, 'apprenant') ? undefined : TextSearchFromJSON(json['apprenant']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardAbsenceSearchToJSON(value?: DashboardAbsenceSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apprenant': TextSearchToJSON(value.apprenant),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

